export const path = "/sounds";

export const apiUrls = {
  settings: "/api/sounds/settings",
  compiler: "/api/sounds/compiler",

  backgrounds: "/api/sounds/backgrounds",
  backgroundsInfo: "/api/sounds/backgrounds/bg_{bgId}",
  backgroundsVolume: "/api/sounds/backgrounds/bg_{bgId}/changeVolume",

  voices: "/api/sounds/voices",
  origins: "/api/sounds/voices/origins",
  voicesInfo: "/api/sounds/voices/voice_{voiceId}",
  voicesSample: "/api/sounds/voices/voice_{voiceId}/testSound",
};
